<mat-dialog-content>
  <div class="content">
    <p>You've been idle for 30 minutes.</p>
    <p>Confirm you're online and ready to receive manual tasks assigned.</p>
    <p class="timer">{{ timeRemaining$ | async | date:'mm:ss' }}</p>
  </div>
  <div class="actions">
    <button mat-button color="accent" mat-dialog-close (click)="stayOffline()">
      I am currently busy
    </button>
    <button mat-raised-button color="primary" mat-dialog-close (click)="close()">
      Stay available
    </button>
  </div>
</mat-dialog-content>
